import { render, staticRenderFns } from "./LessonNav.vue?vue&type=template&id=006f435a&scoped=true&"
import script from "./LessonNav.vue?vue&type=script&lang=js&"
export * from "./LessonNav.vue?vue&type=script&lang=js&"
import style0 from "./LessonNav.vue?vue&type=style&index=0&id=006f435a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006f435a",
  null
  
)

export default component.exports